import React from 'react';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/system';

function SubmitReviewButton({ onClick, loading, variant }) {
    const theme = useTheme();

    return (
        <LoadingButton onClick={onClick} loading={loading}  position='relative' color = 'inherit' variant='extended'  sx={{ 
            width: '100%', alignSelf: 'center', borderRadius: '4px', opacity: 1,  boxShadow: 1, 
            bgcolor: `${theme.palette.blue.main}`,
            '&:hover': {
                bgcolor: `${theme.palette.blue.main}`}
        }}>
            Submit { variant === 'feedback' ? 'Feedback' : 'Changes'}
        </LoadingButton> 
    );
}

export default SubmitReviewButton;